type SectionHeadingProps = {
  index: string;
  title: string;
  subtitle?: string;
};

export default function SectionHeading({ index, title, subtitle }: SectionHeadingProps) {
  return (
    <div className="flex items-start gap-4 border-b border-background-200/70 pb-6">
      <span className="mt-1 font-heading text-sm font-bold tracking-widest text-accent-600">
        {index}
      </span>
      <div>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}